import { createSocketService } from '@tl4k/frontend-shared';

export const socketService = createSocketService({ logPrefix: 'AdminUI' });
